import React from 'react'

import RowAction from './RowAction.container'

import {RowActionWrapper} from './TableRowActions.styles'

import Kebabmenu from '../../../kebabmenu'

const TableRowActionsComponent = ({dataItems, env, dataRow, selectedRows, events, analytics}) => {
  const items = dataItems.map((dataItem, i) => {
    if (dataItem && dataItem.type === 'kebab' && selectedRows.length < 1) {
      return (
        <RowActionWrapper key={'action_' + i}>
          <div key={'tableRowAction_' + i} style={{display: 'inline-block'}}>
            <Kebabmenu actions={dataItem.actions} env={env} dataRow={dataRow} analytics={analytics} />
          </div>
        </RowActionWrapper>
        
      )
    }

    return (
      <RowAction key={'action_' + i} dataItem={dataItem} dataRow={dataRow} env={env} analytics={analytics} />
    )
  })

  return items.reverse()
}

export default TableRowActionsComponent
